import { readingModeResource as aggReadingModeResource } from '@townsquare/agg-reading-mode-view/resources';
import Loadable from '@townsquare/loadable';
import { GlobalHomePageRoute } from '@townsquare/router/route-types';
import {
	readingModeRoute,
	goalsAppReadingModeRoute,
	projectsAppReadingModeRoute,
} from '@townsquare/routes/reading-mode-view';

import { readingModeResource } from './resources/readingMode';

// Reading Mode View
const ReadingModeViewLoadable = Loadable({
	loader: () => import(/* webpackChunkName: "reading-mode-view" */ './ui/index'),
	loading: () => null,
});

const AggReadingModeViewLoadable = Loadable({
	loader: () =>
		import(/* webpackChunkName: "agg-reading-mode-view" */ '@townsquare/agg-reading-mode-view/ui'),
	loading: () => null,
});

readingModeRoute.component = ReadingModeViewLoadable;
readingModeRoute.resources = [readingModeResource];
readingModeRoute.featureGating = {
	gates: ['goal_types_m3_bundled_updates'],
	behavior: {
		type: 'override',
		override: {
			component: AggReadingModeViewLoadable,
			resources: [aggReadingModeResource],
		},
	},
};
export const readingModeRouterRoute: GlobalHomePageRoute = readingModeRoute;

// When cleaning up goal_types_m3_bundled_updates we should move all the route
// definitions over to the new agg-reading-mode package, update any imports,
// and remove this entire package.
goalsAppReadingModeRoute.component = ReadingModeViewLoadable;
goalsAppReadingModeRoute.resources = [readingModeResource];
goalsAppReadingModeRoute.featureGating = {
	gates: ['goal_types_m3_bundled_updates'],
	behavior: {
		type: 'override',
		override: {
			component: AggReadingModeViewLoadable,
			resources: [aggReadingModeResource],
		},
	},
};
export const goalsAppReadingModeRouterRoute: GlobalHomePageRoute = goalsAppReadingModeRoute;

projectsAppReadingModeRoute.component = ReadingModeViewLoadable;
projectsAppReadingModeRoute.resources = [readingModeResource];
projectsAppReadingModeRoute.featureGating = {
	gates: ['goal_types_m3_bundled_updates'],
	behavior: {
		type: 'override',
		override: {
			component: AggReadingModeViewLoadable,
			resources: [aggReadingModeResource],
		},
	},
};
export const projectsAppReadingModeRouterRoute: GlobalHomePageRoute = projectsAppReadingModeRoute;
